import Vue from 'vue'
import App from './App.vue'
import 'babel-polyfill'
import router from './router'
import store from './store'
import './registerServiceWorker'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './common/css/main.css'
import util from './common/js/util.js'
 import 'viewerjs/dist/viewer.css';
 import * as filters from './common/js/filter'
 import Blob from "@/common/js/Blob.js"
import Export2Excel from "@/common/js/Export2Excel.js"
import moment from 'moment'
import { baseHttp } from '@/common/js/baseHttp.js'
//使用moment设置时区
moment.locale('zh-cn')
Vue.prototype.$moment = moment
Vue.prototype.$util = util;
Vue.prototype.$baseHttp = baseHttp;
Vue.use(ElementUI);
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
Vue.config.productionTip = false

// Vue.prototype.$httpUrl='http://sf.19940309.xyz:8032'
// Vue.prototype.$httpUrl='https://daoxie.jiyuechuxing.com'
// Vue.prototype.$httpUrl='http://192.168.120.111:8089'
// Vue.prototype.$httpUrl='http://192.168.12.128:8089'
Vue.prototype.$httpUrl='https://bmapi.sjzsdx.cn' // 正式地址
// Vue.prototype.·$httpUrl='https://daoxie.hellouxing.com/dx_test'
Vue.prototype.rulelist = [
	{
		name: "姓名",
		str: "name",
		type: 2
	},{
		name: "手机号",
		str: "phone",
		type: 2
	},{
		name: "身份证号",
		str: "idCard",
		type: 2
	},{
		name: "证件正面照",
		str: "idCardFrontImg",
		type: 1
	},{
		name: "证件背面照",
		str: "idCardBackImg",
		type: 1
	},{
		name: "学位",
		str: "degree",
		type: 1
	},
	{
		name: "专业",
		str: "major",
		type: 1
	},
	{
		name: "毕业时间",
		str: "graduationDate",
		type: 1
	},
	{
		name: "通讯地址",
		str: "graduateSchool",
		type: 2
	},
	{
		name: "邮箱",
		str: "email",
		type: 2
	},
	{
		name: "专业技术职务",
		str: "technicalPosition",
		type: 1
	},
	{
		name: "民族",
		str: "nation",
		type: 1
	},
	{
		name: "证件类型",
		str: "idType",
		type: 1
	},
	{
		name: "出生日期",
		str: "birthday",
		type: 1
	},
	// {
	// 	name: "联系电话",
	// 	str: "recipientsPhone",
	// 	type: 2
	// },
	// {
	// 	name: "证书邮寄地址",
	// 	str: "mailingAddress",
	// 	type: 1
	// },
	{
		name: "受聘日期",
		str: "employedDate",
		type: 1
	},
	{
		name: "累计从事道路运输工作年限",
		str: "yearsOfWorking",
		type: 2
	},
	{
		name: "企业联系人",
		str: "companyContacts",
		type: 2
	},
	{
		name: "企业联系人电话",
		str: "companyContactsPhone",
		type: 2
	},
	{
		name: "考试科目",
		str: "examSubject",
		type: 1
	}
]

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
